"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectFontFamilyOption')(function selectFontFamilyOption(fontFamily, state) {
    var optionState = state.optionState;
    optionState.fontFamily = fontFamily;
}));
//# sourceMappingURL=selectFontFamilyOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-message-format-option/lib/actions/selectFontFamilyOption.js
// module id = 5152
// module chunks = 2